var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5093 5.88308C21.9576 5.49678 22.0077 4.82025 21.6214 4.372C21.2351 3.92375 20.5587 3.87353 20.1104 4.25982C17.8793 6.18255 16.2251 7.89169 14.8317 9.95782C13.6747 11.6734 12.7191 13.6032 11.7531 16.0526L7.98822 12.3641C7.56553 11.95 6.88718 11.957 6.47308 12.3797C6.05896 12.8024 6.06593 13.4807 6.48862 13.8948L11.4237 18.7296C11.6835 18.9842 12.0548 19.0896 12.4096 19.0094C12.7644 18.9292 13.0543 18.6744 13.1795 18.333C14.3263 15.2033 15.3553 13.0138 16.6083 11.156C17.8574 9.30365 19.3603 7.73502 21.5093 5.88308Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.2acb1cf6.svg";
export { ForwardRef as ReactComponent };